export default class Counter {
    static init() {
        const counters = document.querySelectorAll('.jsCounter');

        if (counters.length > 0) {
            counters.forEach( counter => {
                let input = counter.querySelector('.jsCounterInput');
                let minus = counter.querySelector('.jsCounterControlMinus');
                let plus = counter.querySelector('.jsCounterControlPlus');
                if (input && minus && plus) {

                    minus.addEventListener('click', () => {
                        let prev = input.value;
                        if (parseInt(prev) !== 0 ) {
                            input.value = parseInt(prev) - 1;
                        }
                    });

                    plus.addEventListener('click', () => {
                        let prev = input.value;
                        input.value = parseInt(prev) + 1;
                    });
                }
            });
        }
    }
}